import { render, staticRenderFns } from "./AdditionalChargesExtended.vue?vue&type=template&id=127e52cd&scoped=true&"
import script from "./AdditionalChargesExtended.vue?vue&type=script&lang=js&"
export * from "./AdditionalChargesExtended.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalChargesExtended.vue?vue&type=style&index=0&id=127e52cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127e52cd",
  null
  
)

export default component.exports